"use client";

import { useRef, PropsWithChildren } from "react";
import { JadeProvider, ToastHub } from "@stone-payments/jade";
import { Theme } from "@/types/general";

type Props = {
  theme: Theme;
};

export const PageContainer = ({
  children,
  theme,
}: PropsWithChildren<Props>) => {
  const portalRef = useRef<HTMLDivElement>(null);

  return (
    <JadeProvider theme={theme} portalRoot={portalRef}>
      <ToastHub>
        <div>{children}</div>
        <div ref={portalRef} data-testid="portal-root" />
      </ToastHub>
    </JadeProvider>
  );
};
